// CONSTANTS are all caps.
const NS = "RenewalForm";
const CLS = "renewalForm";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/renewalForm.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

//import Awesomplete from 'Awesomplete';


export class RenewalForm {

	constructor($el) {
		// $el is the widget node return by the loadRenewalForm function
		this.$el = $el;
	}

	init() {
		this.setValidation();
		this.setCountryList();
		this.handleSubmitBtn();
		this.handleCurrency();
	}

	setValidation() {
		$(WG + 'form').validate({
			errorClass: 'is-invalid',
			errorElement: 'span',
		});
	}

	handleSubmitBtn() {
		$(WG + 'btnSubmit').on('click', function(e) {
			e.preventDefault();
			const $form = $(WG + 'form');

			if ($form.valid()) {
				$('#payment_reference').val($('#invoiceNo').val());
				$form.submit();
			}
		});
	}

	setCountryList() {
		let input = document.getElementById('country');
		new Awesomplete(input, {
			list: '#countrylist',
			minChars: 1,
			autoFirst: true,
		});
	}

	handleCurrency() {
		let $wg = $(this.$el);

		$wg.find('#currency_code').on('change', (e) => {
			let target = e.target;
			let txt = target.options[target.selectedIndex].text;
			$wg.find('#currency').val(txt);
		});
	}

	// Add more functions like on above here
}
